import * as animations from './animations'
import * as colors from './colors'
import * as layout from './layout'
import * as typography from './typography'
import * as zIndex from './zIndex'

type Flexible<T> = {
  [Prop in keyof T]: T[Prop] extends string ? string : T[Prop]
}
export type Colors = Flexible<typeof colors>
export type Layout = Flexible<typeof layout>
export type Typography = Flexible<typeof typography>
export type ZIndex = Flexible<typeof zIndex>
export type Animations = Flexible<typeof animations>

export type Theme = Colors &
  Layout &
  Typography & {
    zIndex: ZIndex
  } & Animations

const defaultTheme: Theme = {
  ...colors,
  ...layout,
  ...typography,
  ...animations,
  zIndex,
}

const theme = {
  ...defaultTheme,
}

/**
 * This function overrides theme values in the theme. Very basic theme values
 * are defined in this theme like primary color. This function just replaces
 * the values defined in theme, with the properties and values in newTheme.
 *
 * Styling might change in the future, so even while this function is very
 * simple, it allows us to change it in the future but with type checking
 *
 * @param newTheme Theme variables to override in the theme
 */
export function overrideTheme(newTheme: Partial<Theme>) {
  Object.assign(theme, newTheme)
}

export { defaultTheme }

export default theme
